const getTransitionEnd = () => {

	const transitions = {
		transition: 'transitionend',
		WebkitTransition: 'webkitTransitionEnd',
		MozTransition: 'mozTransitionEnd',
	};

	const el = document.createElement('div');

	return Object.keys(transitions).reduce((accu, curr) => {

		if (accu !== undefined) {
			return accu;
		}

		if (el.style[curr] !== undefined) {
			return transitions[curr];
		}

		return undefined;
	}, undefined);

};

export default getTransitionEnd;
